import { useCallback, useRef, useState } from 'react';
import { toast } from 'sonner';

const LONG_PRESS_MS = 600;

export const canPinShortcut = () => !!(window.AndroidBridge && typeof window.AndroidBridge.addHomeShortcut === 'function');

export function pinShortcut(label, path) {
  if (!canPinShortcut()) { toast.info('Home-screen shortcuts are available in the BBC Android app.'); return false; }
  let ok = false;
  try { ok = !!window.AndroidBridge.addHomeShortcut(label, path); } catch (e) { ok = false; }
  if (ok) toast.success(`"${label}" shortcut requested — confirm on your phone to add it to the home screen.`);
  else toast.error('Your phone did not allow adding a shortcut.');
  return ok;
}

/** Long-press (touch) or right-click on a Social tab/button → offer "Add to phone home screen". */
export function useHomeShortcut() {
  const [target, setTarget] = useState(null); // { label, path, x, y }
  const timer = useRef(null);
  const open = useCallback((label, path, x, y) => setTarget({ label, path, x, y }), []);
  const close = useCallback(() => setTarget(null), []);

  const bind = useCallback((label, path) => ({
    onContextMenu: (e) => { e.preventDefault(); open(label, path, e.clientX, e.clientY); },
    onTouchStart: (e) => {
      const t = e.touches && e.touches[0];
      const x = t ? t.clientX : 0, y = t ? t.clientY : 0;
      clearTimeout(timer.current);
      timer.current = setTimeout(() => open(label, path, x, y), LONG_PRESS_MS);
    },
    onTouchEnd: () => clearTimeout(timer.current),
    onTouchMove: () => clearTimeout(timer.current),
    onTouchCancel: () => clearTimeout(timer.current),
  }), [open]);

  return { target, bind, close };
}
